import {
  type ComponentPropsWithRef,
  type ElementType,
  type ForwardedRef,
  forwardRef,
  type Ref,
  type ReactNode,
  type RefAttributes,
} from 'react';

import { cn } from '~/lib/utils';
import React from 'react';

type FixedForwardRef = <T, P = {}>(
  render: (props: P, ref: Ref<T>) => ReactNode,
  // @TODO: once we update to typescript 5.1 we can change to ReactNode from JSX.Element
) => (props: P & RefAttributes<T>) => JSX.Element;

const fixedForwardRef = forwardRef as FixedForwardRef;

export type DistributiveOmit<T, TOmitted extends PropertyKey> = T extends any ? Omit<T, TOmitted> : never;

export interface ContainerProps<TAs> {
  children: ReactNode;
  className?: string;
  as?: TAs;
}

const UnwrappedContainer = <TAs extends ElementType>(
  {
    className,
    children,
    as: Tag,
  }: ContainerProps<TAs> & DistributiveOmit<ComponentPropsWithRef<ElementType extends TAs ? 'div' : TAs>, 'as'>,
  ref: ForwardedRef<any>,
) => {
  const Element = Tag ? Tag : 'div';

  return <Element className={cn('mx-auto max-w-7xl px-4', className)}>{children}</Element>;
};

export const Container = fixedForwardRef(UnwrappedContainer);
